import { useNavigate } from "react-router-dom"

import "../../styles/Modal.css"

function WarnModal({ warnNav, onClose }) {
  const navigate = useNavigate()
  const handleNav = () => {
    navigate(warnNav)
  }

  return (
    <div className="m-overlay" >

      <div className="wm-content" >
        <div className="m-header" >
          <h4 className="m-title">Attention</h4>
          <button className="m-cancel-button-x" onClick={onClose}>X</button>
        </div>

        <div className="wm-body" >
          <span>If you leave this page your cart will be lost!</span>
          <span>Are you sure?</span>
        </div>

        <div className="m-footer" >
          <div className="m-cancel-order-button-container">
            <button className="m-cancel-button" onClick={onClose}>Cancel</button>
            <button className="m-order-button" onClick={() => handleNav()} >Leave Page</button>
          </div>
        </div>
      </div>

    </div>
  )
}

export default WarnModal
